import React, { FC } from 'react'
import Button from 'components/shared/Button';

import { ReactComponent as LogOutIcon } from 'images/new-icons/log-out.svg';
import { ReactComponent as DeleteAccountIcon } from 'images/new-icons/delete-account.svg';
import useLogout from 'sdk/hooks/useLogout';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import LanguageSwitcher from '../LanguageSwitcher';

type Props = {
    onClose?: () => void
    onDeleteAccount?: ()=> void
}

const ProfileMenuActions: FC<Props> = ({ onClose,onDeleteAccount }) => {
    const {t} = useTranslation() as any
    const navigate = useNavigate()

    const handleLogout = () => {
        logoutMutation.mutate()
        onClose?.()
    }

    const logoutMutation = useLogout(navigate)

    const forgotPassword = () => {
        navigate('/password-reset')
    }

    return (
        <>
                 <LanguageSwitcher />
            <Button darkGreen wide onClick={forgotPassword} >
                {t("Forgot Password")}
            </Button>
            <Button darkGreen wide onClick={handleLogout} >
                <LogOutIcon />
                {t("Log Out")}
            </Button>
    
            <Button ligtGrey wide onClick={onDeleteAccount}>
                <DeleteAccountIcon />
                {t("Delete Account")}
            </Button></>
    )
}

export default ProfileMenuActions